import type { Product } from '@grafikr/shopify-typescript/type/liquid/Product';
import type { ProductMedia } from '@grafikr/shopify-typescript/type/liquid/ProductMedia';
import { Component } from '@grafikr/components';

import clear from 'utils/clear';
import { image as renderImageHTML } from 'utils/image';

interface ProductMediaWithSources extends ProductMedia {
  sources?: {
    format: string;
    height: number;
    mime_type: string;
    url: string;
    width: number;
  }[];
}

export default Component((node) => {
  const allowVideo = node.dataset.allowVideo === 'true';

  document.addEventListener(
    'product:media:updated',
    (e: CustomEvent<{ media: ProductMediaWithSources[]; product: Product }>) => {
      const { media, product } = e.detail;
      let image: ProductMediaWithSources;
      const video = media.find((m) => m.media_type === 'video');

      const isGender = product.tags.some((tag) => ['Male', 'Female'].includes(tag));

      if (allowVideo && video) {
        image = video;
      } else if (isGender) {
        [, image] = media;
      } else {
        [image] = media;
      }

      if (!image) {
        [image] = media;
      }

      if (!image) {
        return;
      }

      clear(node);
      if (image.media_type === 'video') {
        const imageObj = {
          alt: image.alt,
          ...image.preview_image,
        };
        node.insertAdjacentHTML(
          'beforeend',
          `<div data-component="video" data-autoplay="true" class="video">
            <picture>
              ${renderImageHTML(imageObj)}
            </picture>
            <template>
              <video poster="false" playsinline muted loop class="object-cover" preload="metadata">
                ${image.sources
                  .sort((a, b) => b.height - a.height)
                  .map((source) => `<source src="${source.url}" type="${source.mime_type}" />`)
                  .join('')}
                <img alt="${image.alt ?? ''}" src="${image.preview_image.src}" />
              </video>
            </template>
            <div class="video__play-button w-16" data-play>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.5 25.8">
                <g stroke="currentColor" stroke-miterlimit="10">
                  <path fill="none" d="M20.5 12.9L.5.9v24l20-12z"></path>
                  <path d="M.6 1.1v23.6l19.7-11.8L.6 1.1M.5.9l20 12-20 12V.9z"></path>
                </g>
              </svg>
            </div>
          </div>`,
        );
      } else {
        node.insertAdjacentHTML('beforeend', renderImageHTML(image));
      }
    },
  );
});
